module.exports = __webpack_public_path__ + "img/DocNot.240fd70b.png";